export default "__VITE_ASSET__1a1ac6b5__"